import {Component, Input, Output, EventEmitter, OnInit, Renderer, ElementRef} from '@angular/core';
import { ViewController } from "ionic-angular";
import { TaiXiuPage } from "../../../pages/TaiXiu/TaiXiuPage";

@Component({
    selector: 'select-chip',
    templateUrl: 'selectChip.html',
})
export class SelectChipComponent implements OnInit {
    private pageDom: HTMLElement;
    private faceChip = [];
    @Output() evElSelectChip: EventEmitter<any> = new EventEmitter<any>();
    @Output() evClearChips: EventEmitter<any> = new EventEmitter<any>();
    @Input()
    set configUiChip(data) {
        if (data) {
            data.map(item => {
                let objTemp = {};
                objTemp['money'] = item;
                if (item === '1000') {
                    objTemp['cssPosi'] = 'chip chip1k';
                }else if (item === '2000') {
                    objTemp['cssPosi'] = 'chip chip2k';
                }else if (item === '5000') {
                    objTemp['cssPosi'] = 'chip chip5k';
                }else if (item === '10000') {
                    objTemp['cssPosi'] = 'chip chip10k';
                }else if (item === '20000') {
                    objTemp['cssPosi'] = 'chip chip20k';
                }else if (item === '50000') {
                    objTemp['cssPosi'] = 'chip chip50k';
                }else if (item === '100000') {
                    objTemp['cssPosi'] = 'chip chip100k';
                }else if (item === '200000') {
                    objTemp['cssPosi'] = 'chip chip200k';
                }else if (item === '500000') {
                    objTemp['cssPosi'] = 'chip chip500k';
                }else if (item === '1000000') {
                    objTemp['cssPosi'] = 'chip chip1m';
                }else if (item === '2000000') {
                    objTemp['cssPosi'] = 'chip chip2m';
                }else if (item === '5000000') {
                    objTemp['cssPosi'] = 'chip chip5m';
                }
                this.faceChip.push(objTemp);
            });
        }
    }

    constructor(public renderer: Renderer, public viewCtrl: ViewController, public el: ElementRef){
        this.pageDom = el.nativeElement;
    }

    ngOnInit() {}

    dismissSelectChip(event?: any) {
        let elSelectChip = this.pageDom;
        if (elSelectChip.classList.contains('active')) {
            elSelectChip.classList.remove('active');
            setTimeout(() => {
                elSelectChip.classList.remove('showChip');
            }, 200);
        }

        this.evClearChips.emit({
            data: 'closeSelectChips'
        });
    }

    selectedChipMoney(item: any) {
        // close chip popup
        setTimeout(() => {this.dismissSelectChip();}, 250);

        this.evElSelectChip.emit({
            moneyChip: item.money,
            chipClass: item.cssPosi
        });
    }

    clearChips(event: any) {
        this.evClearChips.emit({
            data: 'clearAllChips'
        });
    }

    closeChips(event: any) {
        this.dismissSelectChip();
    }
}


// WEBPACK FOOTER //
// ./src/component/gameTaiXiu/selectChip/selectChip.ts